import { ReducersTypes } from "constants/ReducersTypes";
import moment from "moment";

// date Range Initial
export const dateRange = {
  fromDate: moment().subtract(30, "days").format("MM/DD/YYYY"), // past 30 days
  toDate: moment().format("MM/DD/YYYY"),
};
//column orders for lockbox batches table
export const LOCKBOX_BATCHES_COLUMN_ORDER = [
  "Batch Number",
  "Creation Date",
  "Status",
  "Total Amount",
  "Number of Transactions",
];

export const LOCKBOX_BATCHES_COLUMNS = {
  Name: true,
  "Lockbox Account Number": true,
  Status: true,
  "Declared Total Amount": true,
  "Batch Number": true,
  "Uploaded Date": true,
};

// Query params that drive the API call. Changes here trigger a new fetch.
const initialLockboxBatchesFilters = {
  ...dateRange,
  status: "",
  name: "",
  lockboxAccountNumber: "",
  batchNumber: "",
  page: 1,
  sortBy: "updated_at",
  sortOrder: "desc",
  perPage: 20,
};

// Metadata returned by the API. Never used as a useEffect dependency.
const initialLockboxPagination = {
  nextNum: null,
  prevNum: null,
  pages: null,
  total: null,
};

const initialLockboxState = {
  loading: false,
  lockboxBatches: [],
  filters: { ...initialLockboxBatchesFilters },
  pagination: { ...initialLockboxPagination },
  lockboxBatchDetails: {},
  ftpConfig: {},
};

const lockboxState = (state = initialLockboxState, action) => {
  switch (action.type) {
    case ReducersTypes["SET_LOCKBOX_BATCHES"]:
      return {
        ...state,
        lockboxBatches: action.payload,
      };
    case ReducersTypes["SET_LOCKBOX_PAGINATION"]:
      return {
        ...state,
        pagination: { ...state.pagination, ...action.payload },
      };
    case ReducersTypes["SET_LOCKBOX_BATCHES_FILTERS"]:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
      };
    case ReducersTypes["SET_LOCKBOX_LOADING"]:
      return {
        ...state,
        loading: action.payload,
      };
    case ReducersTypes["SET_LOCKBOX_BATCH_DETAILS"]:
      return {
        ...state,
        lockboxBatchDetails: action.payload,
      };
    case ReducersTypes["SET_LOCKBOX_FTP_CONFIG"]:
      return {
        ...state,
        ftpConfig: action.payload,
      };
    default:
      return state;
  }
};

export default lockboxState;
